let seo = require('../../../actions/seo');
let utils = require('../../../actions/utils');
let page = require('../../../actions/page');
let content = require('../../../actions/layout/content');
let price = require('../../../actions/order/price');
let layoutGroup = require('../../groups/layout');
let userGroup = require('../../groups/user');
let analytics = require('../../../actions/analytics');
let slider = require('../../../actions/order/slider');
let pricesGroup = require('../../groups/prices');

const DEFAULT_POSITIONS = {
    city: 0,
    buildings: 0,
    clouds: 0
};

const START_PAGE = 1;

const setDefaults = [
    utils.set(['slider', 'positions'], DEFAULT_POSITIONS),
    utils.set(['slider', 'page'], START_PAGE)
];

module.exports = [
    page.cleanup(),
    analytics.parseUtmFromQuery,
    utils.set('layout', 'order'),
    ...userGroup.checkAuthCookie([
        ...userGroup.getUser
    ]),
    ...layoutGroup.setMainLayoutBlocks,
    ...setDefaults,
    slider.setComputedFields,
    seo.setDashboardMeta('Данные об организациях: база телефонов, email адресов организаций - Библиотека данных',
        'Официальная библиотека данных 2ГИС: актуальные номера телефонов, email адреса фирм и организаций.'),
    content.setComponentsByLink,
    utils.setPopupVisibility('datepicker', ['order', 'popups', 'datepicker', 'isOpen']),
    utils.setPopupVisibility('datepicker2', ['order', 'popups', 'datepicker2', 'isOpen']),
    price.setIsLoading(true),
    content.setIsLoading(true),
    analytics.pageview,
    pricesGroup.getPrices,
    ...pricesGroup.setComputedFields
];



// WEBPACK FOOTER //
// ./signals/pages/order/index.js